exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._29lss{height:100%;width:100%;display:flex;flex-direction:column;white-space:normal}._29lss img{height:120%;-o-object-fit:cover;object-fit:cover}._29lss:hover img{transition:all .3s ease-in-out;-webkit-transform:scale(1.1);transform:scale(1.1)}._3Kk9g{height:70%;width:100%;overflow:hidden}._2QIUh{background-color:#16161a;height:30%;position:relative}.lTn_s{padding:3px 10px;font-size:14px;line-height:1.4}._3HdMQ{font-size:17.6px;font-size:1.1rem}._3tIEI{padding:0 10px 3px;font-size:16px;font-size:1rem;color:#969696;position:absolute;bottom:5px}._38ORN{font-size:14.4px;font-size:.9rem}", ""]);

// exports
exports.locals = {
	"article_card_container": "_29lss",
	"article_card_image": "_3Kk9g",
	"textContainer": "_2QIUh",
	"article_card_title": "lTn_s",
	"card_small_font": "_3HdMQ",
	"article_card_date": "_3tIEI",
	"date_small_font": "_38ORN"
};